import { PageResponseVm } from 'api/core/page-response.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { StationVm } from './station.vm';

export class GetStationsVm extends PageResponseVm<StationVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => StationVm)
  @ValidateNested({ each: true })
  objects: StationVm[];
}
